import { render, staticRenderFns } from "./SitemapParser.vue?vue&type=template&id=5901f51a"
import script from "./SitemapParser.vue?vue&type=script&lang=js"
export * from "./SitemapParser.vue?vue&type=script&lang=js"
import style0 from "./SitemapParser.vue?vue&type=style&index=0&id=5901f51a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports